import { Estado } from "../Estado";
import { EnumValue } from "./enum-value";

export const EstadoEnum = {
    acre: 'AC',
    alagoas: 'AL',
    amapa: 'AP',
    amazonas: 'AM',
    bahia: 'BA',
    ceara: 'CE',
    espiritoSanto: 'ES',
    goias: 'GO',
    maranhao: 'MA',
    matoGrosso: 'MT',
    matoGrossoDoSul: 'MS',
    minasGerais: 'MG',
    para: 'PA',
    paraiba: 'PB',
    parana: 'PR',
    pernambuco: 'PE',
    piaui: 'PI',
    rioDeJaneiro: 'RJ',
    rioGrandeDoNorte: 'RN',
    rioGrandeDoSul: 'RS',
    rondonia: 'RO',
    roraima: 'RR',
    santaCatarina: 'SC',
    saoPaulo: 'SP',
    sergipe: 'SE',
    tocantins: 'TO',
    distritoFederal: 'DF'
}

export const EstadoValues: EnumValue[] = [
    {
        codigo: EstadoEnum.acre,
        descricao: 'Acre'
    },
    {
        codigo: EstadoEnum.alagoas,
        descricao: 'Alagoas'
    },
    {
        codigo: EstadoEnum.amapa,
        descricao: 'Amapá'
    },
    {
        codigo: EstadoEnum.amazonas,
        descricao: 'Amazonas'
    },
    {
        codigo: EstadoEnum.bahia,
        descricao: 'Bahia'
    },
    {
        codigo: EstadoEnum.ceara,
        descricao: 'Ceará'
    },
    {
        codigo: EstadoEnum.espiritoSanto,
        descricao: 'Espírito Santo'
    },
    {
        codigo: EstadoEnum.goias,
        descricao: 'Goiás'
    },
    {
        codigo: EstadoEnum.maranhao,
        descricao: 'Maranhão'
    },
    {
        codigo: EstadoEnum.matoGrosso,
        descricao: 'Mato Grosso'
    },
    {
        codigo: EstadoEnum.matoGrossoDoSul,
        descricao: 'Mato Grosso do Sul'
    },
    {
        codigo: EstadoEnum.minasGerais,
        descricao: 'Minas Gerais'
    },
    {
        codigo: EstadoEnum.para,
        descricao: 'Pará'
    },
    {
        codigo: EstadoEnum.paraiba,
        descricao: 'Paraíba'
    },
    {
        codigo: EstadoEnum.parana,
        descricao: 'Paraná'
    },
    {
        codigo: EstadoEnum.pernambuco,
        descricao: 'Pernambuco'
    },
    {
        codigo: EstadoEnum.piaui,
        descricao: 'Piauí'
    },
    {
        codigo: EstadoEnum.rioDeJaneiro,
        descricao: 'Rio de Janeiro'
    },
    {
        codigo: EstadoEnum.rioGrandeDoNorte,
        descricao: 'Rio Grande do Norte'
    },
    {
        codigo: EstadoEnum.rioGrandeDoSul,
        descricao: 'Rio Grande do Norte'
    },
    {
        codigo: EstadoEnum.rondonia,
        descricao: 'Rondônia'
    },
    {
        codigo: EstadoEnum.roraima,
        descricao: 'Roraima'
    },
    {
        codigo: EstadoEnum.santaCatarina,
        descricao: 'Santa Catarina'
    },
    {
        codigo: EstadoEnum.saoPaulo,
        descricao: 'São Paulo'
    },
    {
        codigo: EstadoEnum.sergipe,
        descricao: 'Sergipe'
    },
    {
        codigo: EstadoEnum.tocantins,
        descricao: 'Tocantins'
    },
    {
        codigo: EstadoEnum.distritoFederal,
        descricao: 'Distrito Federal'
    }
]

export const getEstadoLabel = (tipo: Estado): string => {
    const match = EstadoValues.find(
      value => value.codigo === tipo
    );
    return match ? match.descricao : '';
  };
